import produce from "immer";
import { IStoreState } from "../initialStoreState";

import { LoadState } from "../../constants/enums";
import { MarketingActions } from ".";
import { defaultMarketingsState } from "./marketing.types";
import { FETCH_MARKETINGS_LIST_FAILED, FETCH_MARKETINGS_LIST_PROGRESS, FETCH_MARKETINGS_LIST_SUCCESS } from "./marketingActions";

export const MarketingsReducer = (
  state: IStoreState["Marketings"] = defaultMarketingsState,
  action: MarketingActions
) => {
  switch (action.type) {
    case FETCH_MARKETINGS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_MARKETINGS_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_MARKETINGS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
